import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { LangContext } from "../../LanguageProvider";

const pdf_kz = "./pdf/pravilapriemkz20242025.pdf";
const pdf_ru = "./pdf/pravilapriemru20242025.pdf";

const StudentAdmissionRules = () => {
  const { translations, lang } = useContext(LangContext);

  const currentPdf = lang === "kz" ? pdf_kz : pdf_ru;

  return (
    <Box
      sx={{
        fontSize: "16px",
        padding: 0,
        maxWidth: "100%",
        marginTop: "100px",
        marginBottom: "100px",
      }}>
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "center" }}>
        <Typography variant="h4" component="h1" sx={{ fontSize: "26px" }}>
          {translations["prav priem"]}{" "}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          01.09.2025
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", height: "800px" }}>
        <iframe
          src={currentPdf}
          title="Student Admission Rules"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>
    </Box>
  );
};

export default StudentAdmissionRules;
